declare module '@mui/material/Tabs' {
  interface TabsPropsIndicatorColorOverrides {
    scrollable: true;
  }
}

export default function MuiTabs(theme: any) {
  return {
    MuiTabs: {
      variants: [
        {
          props: { variant: "scrollable" },
          style: {
            "& .MuiTabs-indicator": {
              backgroundColor: "transparent",
            },

            "& .MuiInputBase-root-MuiInput-root:before": {
              backgroundColor: "transparent",
            },

            "& .MuiSvgIcon-fontSizeSmall": {
              fontSize: "25px",
              color: theme.palette.grey[0],
              marginLeft: "0px",
            },

            "&.MuiTabs-indicator": {
              backgroundColor: theme.palette.grey[0],
            },
          },
        },
      ],
      styleOverrides: {
        root: {},
      },
    },
    MuiTabScrollButton: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          opacity: "1 !important",
          color: theme.palette.grey[0],
          width: "32px",
          "&.Mui-disabled": {
            opacity: "1 !important",
            color: theme.palette.grey[0],
          },
          "& .MuiSvgIcon-fontSizeSmall": {
            margin: 0,
          },
        },
      },
    },
  };
}
